/* eslint-disable react/prop-types */
import React from "react";
import { Dropdown } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import profileIc from "../../assets/png/profile-ic.png";
import numberFormat from "../common/number-format";
import "./VendorPaymentAnalysisTable.css";

export const VendorPaymentAnalysisTable = ({
  vendorList = [],
  hoveredIndex,
  setHoveredIndex,
  vendorPerPage,
  setVendorPerPage,
  pageVendorCount,
  handlePageClick,
}) => {
  return (
    <div className="col-xl-12" style={{ marginTop: "16px" }}>
      <div className="bg-white rounded-4 mt-3 w-100 p-3">
        <h3 className="fs-14 fw-bold textcolor mb-3">
          Vendor-Based Payment Analysis
        </h3>
        <div
          style={{
            display: "flex",
            flex: "10",
            paddingLeft: "16px",
            paddingRight: "16px",
            paddingTop: "16px",
            height: "40px",
            backgroundColor: "#F2F2F2",
          }}
          className="head3 w-100 justify-content-center align-items-center"
        >
          <p
            style={{ width: "127px", flex: "1.5" }}
            className="fs-13 fw-700 textcolor"
          >
            Vendor
          </p>
          <p
            style={{ width: "160px", flex: "1" }}
            className="fs-13 fw-700 textcolor"
          >
            Total Transaction
          </p>
          <p
            style={{ width: "160px", flex: "1" }}
            className="fs-13 fw-700 textcolor"
          >
            Total Amount
          </p>{" "}
          <p
            style={{ width: "160px", flex: "1" }}
            className="fs-13 fw-700 textcolor"
          >
            Paid Amount
          </p>{" "}
          <p
            style={{ width: "160px", flex: "1" }}
            className="fs-13 fw-700 textcolor"
          >
            Pending Amount
          </p>{" "}
        </div>
        <div>
          {Array.isArray(vendorList) && vendorList.length > 0 ? (
            vendorList.map((item, index) => (
              <div
                key={item.vendor_id || item.vendor_name}
                style={{
                  display: "flex",
                  flex: "10",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  backgroundColor:
                    hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                  borderBottom: "1px solid #D4DDE7",
                  cursor: "pointer",
                  height: "44px",
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() => {}}
                className="head3 w-100 justify-content-center align-items-center cursor-pointer"
              >
                <p
                  className="fs-13 fw-500 textcolor"
                  style={{
                    flex: "1.5",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    marginTop: "16px",
                  }}
                  title={item.vendor_name}
                >
                  <img
                    src={
                      item.image && item.image.trim() !== ""
                        ? item.image
                        : profileIc
                    }
                    alt="Profile"
                    className="avatar-item me-1 ms-0"
                  />
                  {item.vendor_name ?? "---"}
                </p>
                <div
                  className="fs-13 fw-500 textcolor"
                  style={{
                    flex: "1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                  title={item.transaction_count}
                >
                  {item.transaction_count ?? "0"}
                </div>
                <div
                  className="fs-13 fw-500 textcolor"
                  style={{
                    flex: "1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                  title={item.total_amount}
                >
                  ₹ {numberFormat(item.total_amount)}
                </div>
                <div
                  className="fs-13 fw-500 textcolor"
                  style={{
                    flex: "1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                  title={item.paid_amount}
                >
                  ₹ {numberFormat(item.paid_amount)}
                </div>
                <div
                  className="fs-13 fw-500 textcolor"
                  style={{
                    flex: "1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                  title={item.pending_amount}
                >
                  ₹ {numberFormat(item.pending_amount)}
                </div>
              </div>
            ))
          ) : (
            <div className="d-flex align-items-center justify-content-center textGrey fs-14 fw-500" style={{ height: "100px" }}>
              No records found.
            </div>
          )}
        </div>
        <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
          <Dropdown>
            <span className="fs-13 fw-500 textcolor">
              Records per page: &nbsp;
            </span>
            <Dropdown.Toggle
              id="dropdown-basic"
              className="bg-transparent fs-13 fw-500 textcolor border-0 custom-dropdown-toggle p-0"
            >
              <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                {vendorPerPage} <DownArrowIc />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="my-2"
              style={{ minWidth: "unset", width: "30%" }}
            >
              {[5, 10, 25, 50, 75, 100].map((size) => (
                <Dropdown.Item
                  key={size}
                  onClick={() => {
                    setVendorPerPage(size);
                  }}
                  active={vendorPerPage === size}
                  className="text-center fs-13 fw-500 textcolor"
                >
                  {size}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <div className="d-flex align-items-center gap-2">
            <ReactPaginate
              previousLabel={
                <div
                  className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "22px",
                    height: "22px",
                  }}
                >
                  <LarIc />
                </div>
              }
              nextLabel={
                <div
                  className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "22px",
                    height: "22px",
                  }}
                >
                  <RarIc />
                </div>
              }
              breakLabel={"..."}
              pageCount={pageVendorCount + 1}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
